import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMicrosoftLogin } from '../LoginPage/hooks/UseMicrosoftLogin'
import './styles.css'

export default function AzureCallbackPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { microsoftLogin, isLoading } = useMicrosoftLogin()
  const hasAttempted = useRef(false)

  useEffect(() => {
    // Evitar múltiples intentos
    if (hasAttempted.current) return
    hasAttempted.current = true

    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const error = params.get('error')
    const errorDescription = params.get('error_description')

    if (error) {
      console.error('Microsoft OAuth Error:', error, errorDescription)
      navigate('/login', { replace: true })
      return
    }

    if (code) {
      const redirectUri = `${window.location.origin}/azure/auth/callback`
      microsoftLogin(code, redirectUri)
        .then(() => {
          // El hook ya maneja la navegación al dashboard después del login exitoso
        })
        .catch(() => {
          // El hook ya maneja los errores
          navigate('/login', { replace: true })
        })
    } else {
      // Si no hay code ni error, redirigir al login
      navigate('/login', { replace: true })
    }
  }, [])

  return (
    <div className="azure-callback-page">
      <div className="azure-callback-container">
        {isLoading ? (
          <>
            <div className="spinner"></div>
            <p>{t('auth.authenticatingMicrosoft')}</p>
          </>
        ) : (
          <p>{t('auth.processingAuth')}</p>
        )}
      </div>
    </div>
  )
}
